module.exports = __webpack_public_path__ + "static/media/arrow.b6d9459f.svg";